<div class="alert-holder" >
	<alert [dismissOnTimeout]="timeout" [dismissible]="true" (onClosed)="close(msg)" *ngFor="let msg of messages" type="{{msg.type}}">{{msg.message}}</alert>
</div>
